module.exports = __webpack_public_path__ + "img/2.e4f1b016.jpg";